/** Axis tick font size shared by the dashboard charts (0.9rem) */
export const CHART_TICK_FONT_SIZE = 14.4;
